export class DesignBaseModel {
    _id: string;
    name: string;
    description: string;
    displacementBeam: number;
    displacementBracket: number;
    safetyFactor: number;
    shearFactor: number;
    bucklingLenght: number;
    minDeflectionLimit: number;

    constructor(id = null,
        name = '',
        description = '',
        displacementBeam = null,
        displacementBracket = null,
        safetyFactor = null,
        shearFactor = null,
        bucklingLenght = null,
        minDeflectionLimit = null) {
            this._id = id;
            this.name = name;
            this.description = description;
            this.displacementBeam = displacementBeam;
            this.displacementBracket = displacementBracket;
            this.safetyFactor = safetyFactor;
            this.shearFactor = shearFactor;
            this.bucklingLenght = bucklingLenght;
            this.minDeflectionLimit = minDeflectionLimit;
    }
}
